import React from "react";
import {observer, inject} from "mobx-react";
import {observable} from 'mobx';
import {withRouter, Route, Switch} from "react-router-dom";
import Select, {components} from 'react-select';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ToolbarDropdown, ToolbarSection} from "@components/Toolbar/ToolbarDropdown"
import ErrorBoundry from "@components/ErrorBoundry/ErrorBoundry";
import AddressEdit from "@components/mypages/AddressEdit";
import Spinner from "@utils/spinner";

const SingleValue = ({children, ...props}) => (
    <components.SingleValue {...props}>
        {props.data.AddressId === -1 ? <React.Fragment>Custom Address</React.Fragment> :
            <React.Fragment>
                <small><strong>{props.data.CompanyName}</strong></small><br/>
                {props.data.Line1}, {props.data.PostalCode} {props.data.City}</React.Fragment>}
    </components.SingleValue>
);

const customSelectStyles = {

    menu: (provided, state) => ({
        ...provided,
        zIndex:2
 
    }),

};



@inject("store")
@observer
class BerikssonPurchaseOrderCheckout extends React.Component {
    @observable SelectedCustomerId = "";
    @observable SelectedAddress = "";
    @observable footerExpanded = false;
    @observable headerExpanded = false;
    @observable addProduct = null;
    @observable processingCheckout = false;
    @observable splitOrderSettingsVisible = false;

    constructor(props) {
        super(props);
        this.formatAddress = this.formatAddress.bind(this);
        this.formatShipping = this.formatShipping.bind(this);
        this.formatPayment = this.formatPayment.bind(this);
        this.toggleExpandedFooter = this.toggleExpandedFooter.bind(this);
        this.toggleExpandedHeader = this.toggleExpandedHeader.bind(this);

        this.openProduct = this.openProduct.bind(this);
        this.checkout = this.checkout.bind(this);
        this.addProductSelect = null;
        this.updateNote = this.updateNote.bind(this);
        this.saveNote = this.saveNote.bind(this);
        //this.setSplitOrderVisibility = this.setSplitOrderVisibility.bind(this);
        this.changeAddress = this.changeAddress.bind(this);
        this.changeShippingMethod = this.changeShippingMethod.bind(this);
        this.changePaymentMethod = this.changePaymentMethod.bind(this);
        this.addProductRef = element => {
            this.addProductSelect = element;
        };


        this.addCustomAddress = this.addCustomAddress.bind(this);
        this.isCustomAddressValid = this.isCustomAddressValid.bind(this);
        this.state = {
            isCustomAddressValid: false,
            ShowCustomShippingAddress: false,
            checkoutLoaded: false

        }
    }

    isCustomAddressValid(isValid) {

        this.setState({isCustomAddressValid: isValid});
    }

    addCustomAddress() {
        this.setState({showCustomAddress: true});
    }

    formatAddress(address) {
        if (address.AddressId === -1) {
            return (<div><strong>Lägg till en adress</strong></div>);
        }
        return (<div className={"d-flex"}>
            <div style={{flex: "0 0 50%"}}>
                <strong>{address.CompanyName}</strong>
                <br/>{address.Line1}<br/>{address.PostalCode} {address.City} <br/>{address.CountryName}
            </div>
            <div style={{flex: "0 0 50%"}}>
                {address.FirstName} {address.LastName}, {address.PhoneNumber}
            </div>
        </div>);
    }

    formatShipping(shippingMethod) {
        return (<div><strong>{shippingMethod.DisplayName}</strong> - {shippingMethod.PriceFormatted} {this.props.store.order.activeOrder.Currency}<br/>{shippingMethod.Description}</div>);
    }

    formatPayment(paymentMethod) {
        return (<div><strong>{paymentMethod.DisplayName}</strong><br/>{paymentMethod.Description}</div>);
    }

    toggleExpandedHeader() {
        this.headerExpanded = !this.headerExpanded;
    }

    toggleExpandedFooter() {
        this.footerExpanded = !this.footerExpanded;
    }

    toggleImport() {
        this.importData = {};
        this.importVisible = !this.importVisible;
    }


    formatProduct(product) {
        return (<div className="text-left"><strong>{product.Name}</strong><br/>{product.Sku}<img src={product.PrimaryImageUrl + "?width=80"}/></div>);
    }

    openProduct(product) {
        if (product && product.Sku) {
            const navigation = this.props.store.navigation;
            navigation.openProductDialog(product.Sku);
        }
    }

    saveNote(value) {
        const orderStore = this.props.store.order;
        orderStore.activeOrder.update();
        //orderStore.activeOrder.update();
    }

    updateNote(e) {
        const orderStore = this.props.store.order;
        orderStore.activeOrder.setNote(e.target.value);
    }

    checkout() {
        const orderStore = this.props.store.order;

        this.processingCheckout = true;
        setTimeout(() => {
                orderStore.activeOrder.checkout().then(
                    result => {
                        this.props.store.order.fetchOrders().then(success => {
                            this.processingCheckout = false;
                            this.props.store.navigation.openThankYou(result.OrderNumber);
                        });
                    },
                    error => {
                        alert(error.message);
                        this.processingCheckout = false;
                    });
            },
            100);

    }


    // setSplitOrderVisibility() {
    //     const order = this.props.store.order.activeOrder;
    //     if (order && order.SplitOrders) {
    //         this.splitOrderSettingsVisible = order.SplitOrders.length > 0;
    //     }
    // }


    componentDidMount() {
        const order = this.props.store.order.activeOrder;
        // if (order && this.splitOrderSettingsVisible === false) {
        //     this.setSplitOrderVisibility();
        // }

        // if (order && order.ShippingAddressName != null && order.ShippingAddressName === "" && order.ShippingAddress != null) {
        //     this.setState({ShowCustomShippingAddress: true});
        // }

        if (this.props.store.order.activeOrder && this.processingCheckout === false) {
            this.loadCheckout();

        }

    }

    loadCheckout() {
        this.props.store.order.activeOrder.checkoutStart().then((success) => {
            this.setState({checkoutLoaded: true});
        });
    }

    componentWillUnmount() {
        if (this.props.store.order.activeOrder && this.processingCheckout === false) {
            this.props.store.order.activeOrder.checkoutCancel();
        }

    }

    componentWillReact() {
        const order = this.props.store.order.activeOrder;
        const navigation = this.props.store.navigation;
        // CheckoutTimeout..


        // console.log("componentWillReact: checkoutStarted", order.CheckoutStarted);
        if (order && order.CheckoutStarted && order.CheckoutTimeoutSecondsLeft === 0) {
            alert("Checkout timed out. Please retry if you still would like to checkout your order.");
            navigation.openOrder();
            //console.log("Send outside");
        } else if (order && !order.CheckoutStarted) {
            navigation.openOrder();
            //console.log("Send outside, quiet...");
        }


        // if (order && this.splitOrderSettingsVisible === false) {
        //     this.setSplitOrderVisibility();
        // }

        //if (order.ShippingAddressName != null && order.ShippingAddressName === "" && order.ShippingAddress != null) {
        //    this.setState({ ShowCustomShippingAddress: true});
        //}


    }

    changeAddress(address) {
        const orderStore = this.props.store.order;

        // if (address.AddressId === -1) {
        //     this.setState({ShowCustomShippingAddress: true});
        // } else {
        //     this.setState({ShowCustomShippingAddress: false});
        // }
        orderStore.activeOrder.setShippingAddressName(address.AddressName);
    }

    changeShippingMethod(shippingMethod) {
        const orderStore = this.props.store.order;

        orderStore.activeOrder.setShippingMethod(shippingMethod.ShippingMethodId);
    }

    changePaymentMethod(paymentMethod) {
        const orderStore = this.props.store.order;

        orderStore.activeOrder.setPaymentMethod(paymentMethod.PaymentMethodId);
    }


    render() {

        //console.log("splitOrderSetting", this.splitOrderSettingsVisible);

        const {store} = this.props;
        const orderStore = store.order;
        const activeOrder = this.props.store.order.activeOrder;

        if (!activeOrder) {
            return null;
        }


        const customerId = this.props.store.navigation.getCustomerId();
        const currentCustomer = this.props.store.account.Customers.find(x => x.Id === customerId);

        // The component will not react to changes if its not referenced in the render method.. so here goes:
        if (activeOrder) {
            const checkoutStarted = activeOrder.CheckoutStarted;
            const checkoutTimeoutSecondsLeft = activeOrder.CheckoutTimeoutSecondsLeft;
            //console.log("PurchaseOrderCheckout->Render, checkoutStarted:", checkoutStarted);
        }

        const headerClasses = [
            "purchaseorder-header",
            "checkout",
            //this.splitOrderSettingsVisible ? "expanded-settings" : null,
            this.headerExpanded ? "expanded" : null
        ];

        const footerClasses = [
            "purchaseorder-footer",
            "checkout",
            //this.splitOrderSettingsVisible ? "expanded-settings" : null,
            this.footerExpanded ? "expanded" : null
        ];


        const parentMatch = this.props.match;


        const addresses = [...orderStore.Addresses];
        const shippingMethods = activeOrder
            ? activeOrder.ShippingMethods.toJSON()
            : [];

        const paymentMethods = activeOrder
            ? activeOrder.PaymentMethods.toJSON()
            : [];

        //addresses.unshift({ AddressId: -1, AddressName:"" });

        return (
            <ToolbarDropdown key={"checkout"} {...this.props} match={parentMatch}>
                <ToolbarSection>
                    <div className="purchaseorder">
                        <div className="purchaseorder-inner">
                            <div className={headerClasses.join(' ')}>

                                {!orderStore.activeOrder ? "Laddar order..." :
                                    <React.Fragment>
                                        <div className="d-flex">
                                            <div className="" style={{flex: 1}}>
                                                <div className="form-group mb-3 " style={{position: "relative"}}>


                                                    {/*<label className="text-muted " htmlFor="text-input">Order</label>*/}

                                                    <select

                                                        style={{background: "#e5e5e5"}}
                                                        className="form-control form-control-sm"
                                                        disabled={true}
                                                        readOnly
                                                        value={orderStore.activeOrder ? orderStore.activeOrder.OrderGuid : ""}
                                                        //onChange={(e) => { orderStore.setActiveOrder(e.target.value) }}

                                                    >

                                                        {orderStore.Orders.map(order => (
                                                            <option key={order.OrderGuid}
                                                                    value={order.OrderGuid}>Order: {order.OrderNumber} {orderStore.activeOrder ? ` - Önskad leverans: ${orderStore.activeOrder.DeliveryDate}` : ""} {order.Reference ? ` - (${order.Reference})` : ""}</option>
                                                        ))}
                                                    </select>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <hr style={{borderTopColor: "#b7b7b7"}}/>
                                            </div>
                                        </div>
                                        {/*{!orderStore.activeOrder ? null :*/}
                                        {/*    <React.Fragment>*/}
                                        {/*        <div className="row mt-2 hidden-xs-down">*/}
                                        {/*            <div className="col-6">*/}
                                        {/*            </div>*/}

                                        {/*            <div className="col-6 text-right pr-4">Artiklar/Kvantitet: <strong>{orderStore.activeOrder.RowsCount}/{orderStore.activeOrder.OrderArticleCount}</strong>*/}
                                        {/*                {orderStore.activeOrder.RowsCountNA === 0 ? null :*/}
                                        {/*                    <React.Fragment>*/}
                                        {/*                        <br/>+ N/A: {orderStore.activeOrder.RowsCountNA}/{orderStore.activeOrder.OrderArticleCountNA}*/}
                                        {/*                        <strong><br/>=*/}
                                        {/*                            Total: {orderStore.activeOrder.RowsCount + orderStore.activeOrder.RowsCountNA}/{orderStore.activeOrder.OrderArticleCount + orderStore.activeOrder.OrderArticleCountNA}*/}
                                        {/*                        </strong>*/}
                                        {/*                    </React.Fragment>*/}
                                        {/*                }*/}
                                        {/*            </div>*/}

                                        {/*        </div>*/}
                                        {/*    </React.Fragment>*/}
                                        {/*}*/}

                                    </React.Fragment>
                                }

                            </div>

                            {/*<div className="d-flex purchaseorder-content-header ">*/}
                            {/*    <div className="image"></div>*/}
                            {/*    <div className="name">Artikel</div>*/}
                            {/*    <div className="price">À Pris</div>*/}
                            {/*    <div className="quantity">Antal</div>*/}
                            {/*</div>*/}
                            {/*{!orderStore.activeOrder ? null*/}
                            {/*    : <React.Fragment><PurchaseOrderList order={orderStore.activeOrder}*/}
                            {/*                                         readOnly={true}/></React.Fragment>}*/}
                            <div className="purchaseorder-content scroll-content">
                            </div>
                            
                            <div className={footerClasses.join(' ')}>


                                {!orderStore.activeOrder ? null :
                                    <React.Fragment>

                                        
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group mb-3">
                                                    <label className="text-muted" htmlFor="text-input">Välj
                                                        leveransadress</label>
                                                    <span className={"float-right"}><a
                                                        href={"/sv-se/mina-sidor/adresser"}
                                                        onClick={(e) => {
                                                            this.props.store.navigation.closeToolbar(true, () => {
                                                                this.props.store.navigation.aHrefNavigation(e)
                                                            });
                                                        }
                                                        }
                                                    >Redigera/Lägg till adress</a></span>
                                                    <div className="addresses-container">
                                                        <Select

                                                            styles={customSelectStyles}
                                                            isDisabled={!orderStore.activeOrder.CheckoutStarted || (!orderStore.activeOrder.CheckoutStarted && orderStore.activeOrder.Readonly)}
                                                            getOptionLabel={(address) => {
                                                                return this.formatAddress(address)
                                                            }}
                                                            components={{SingleValue}}
                                                            className="addresses-dropdown"
                                                            placeholder="Klicka för att välja adress..."
                                                            getOptionValue={(address) => {
                                                                return address;
                                                            }}
                                                            value={
                                                                (orderStore.activeOrder.ShippingAddressName || this.state.ShowCustomShippingAddress) &&
                                                                addresses.find(address => address.AddressName === orderStore.activeOrder.ShippingAddressName || (this.state.ShowCustomShippingAddress && address.AddressId === -1))
                                                            }
                                                            onChange={(address) => this.changeAddress(address)}
                                                            options={addresses}/>
                                                    </div>
                                                    {this.state.ShowCustomShippingAddress &&
                                                        <AddressEdit order={orderStore.activeOrder}
                                                                     isValidCallback={this.isCustomAddressValid}/>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-6 pr-1">
                                                <div className="form-group mb-3">
                                                    <label className="text-muted" htmlFor="text-input">Välj
                                                        fraktsätt</label>
                                                    <div className="addresses-container">
                                                        <Select
                                                            styles={customSelectStyles}
                                                            isDisabled={!orderStore.activeOrder.CheckoutStarted || (!orderStore.activeOrder.CheckoutStarted && orderStore.activeOrder.Readonly)}
                                                            getOptionLabel={(shippingMethod) => {
                                                                return this.formatShipping(shippingMethod)
                                                            }}
                                                            //components={{ SingleValue }}
                                                            placeholder="Välj..."
                                                            className="addresses-dropdown"
                                                            getOptionValue={(shippingMethod) => {
                                                                return shippingMethod;
                                                            }}
                                                            value={
                                                                activeOrder.ShippingMethodId
                                                                    ? activeOrder.ShippingMethods.find(shippingMethod => shippingMethod.ShippingMethodId === activeOrder.ShippingMethodId)
                                                                    : null
                                                            }
                                                            onChange={(shippingMethod) => this.changeShippingMethod(shippingMethod)}
                                                            options={shippingMethods}/>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-6 pl-1">
                                                <div className="form-group mb-3">
                                                    <label className="text-muted" htmlFor="text-input">Välj
                                                        betalsätt</label>
                                                    <div className="addresses-container">
                                                        <Select
                                                            styles={customSelectStyles}
                                                            isDisabled={!orderStore.activeOrder.CheckoutStarted || (!orderStore.activeOrder.CheckoutStarted && orderStore.activeOrder.Readonly)}
                                                            getOptionLabel={(paymentMethod) => {
                                                                return this.formatPayment(paymentMethod)
                                                            }}
                                                            //components={{ SingleValue }}
                                                            className="addresses-dropdown"
                                                            getOptionValue={(paymentMethod) => {
                                                                return paymentMethod;
                                                            }}
                                                            value={
                                                                activeOrder.PaymentMethodId
                                                                    ? activeOrder.PaymentMethods.find(paymentMethod => paymentMethod.PaymentMethodId === activeOrder.PaymentMethodId)
                                                                    : null
                                                            }
                                                            onChange={(paymentMethod) => this.changePaymentMethod(paymentMethod)}
                                                            options={paymentMethods}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group mb-3">
                                                    <label className="text-muted"
                                                           htmlFor="text-input">Meddelande</label>
                                                    <textarea className="form-control" id="textarea-input" rows="2"
                                                              onChange={this.updateNote}
                                                              value={orderStore.activeOrder.Note}
                                                              onBlur={this.saveNote}></textarea>
                                                </div>
                                            </div>
                                        </div>

                                        <div className={"cart-inner"}>
                                            <div className={"cart-footer"}>

                                                <dl className="cart-order-totals">
                                                    <dt className="">{this.props.store.navigation.dictionary.SubTotalExTax || "Subtotal"}
                                                    </dt>

                                                    <dd>
                                                        {orderStore.activeOrder.Updating
                                                            ? <Spinner/>
                                                            :
                                                            <strong>{orderStore.activeOrder.SubTotalFormatted + " " + orderStore.activeOrder.Currency}</strong>}
                                                    </dd>

                                                    <dt>
                                                        {this.props.store.navigation.dictionary.Shipping}
                                                    </dt>
                                                    <dd>{orderStore.activeOrder.Updating
                                                        ? <Spinner/>
                                                        :
                                                        <strong>{orderStore.activeOrder.ShippingTotalExTaxFormatted + " " + orderStore.activeOrder.Currency}</strong>}
                                                    </dd>
                                                    <dt>

                                                    </dt>
                                                    <dd>{orderStore.activeOrder.Updating
                                                        ? <Spinner />
                                                        : <React.Fragment>
                                                            <span className={"free-shipping-info " + (parseFloat(orderStore.activeOrder.FreeShippingInfo) > 0 && orderStore.activeOrder.ShippingTotal !== 0 ? "left" : "free")}>
                                                                {parseFloat(orderStore.activeOrder.FreeShippingInfo) > 0 && orderStore.activeOrder.ShippingTotal !== 0
                                                                    ? this.props.store.navigation.dictionary.FreeShippingInfo.replace("{0}", orderStore.activeOrder.FreeShippingInfo)
                                                                    : this.props.store.navigation.dictionary.FreeShipping}
                                                            </span>
                                                        </React.Fragment>
                                                    }
                                                    </dd>


                                                    <dt className="cart-sum-total">{this.props.store.navigation.dictionary.TotalInclTax}</dt>
                                                    <dd className="cart-sum-total">
                                                        <strong>{orderStore.activeOrder.OrderTotalFormatted === "0.00" || orderStore.activeOrder.OrderTotalFormatted === "0,00" ? 0 : orderStore.activeOrder.OrderTotalFormatted} {orderStore.activeOrder.Currency}</strong>
                                                        <br/><span
                                                        className="vat-info">{this.props.store.navigation.dictionary.VatTotal} {orderStore.activeOrder.TaxTotal > 0 ? orderStore.activeOrder.TaxTotalFormatted : 0} {orderStore.activeOrder.Currency}</span>
                                                    </dd>


                                                </dl>


                                                <div className="basket-cta-container mt-2">
                                                    <div className="d-flex">

                                                        <button
                                                            onClick={() => {
                                                                this.props.store.navigation.mainRouter.goBack();
                                                            }}
                                                            style={{flex: "0 0 33%"}}
                                                            className="product-button-purchase cancel mr-2"
                                                        >
                                                            <FontAwesomeIcon icon={["fas", "angle-left"]}/> Varukorg

                                                        </button>


                                                        <button
                                                            disabled={!(orderStore.activeOrder.Valid && orderStore.activeOrder.HasShippingAddress && orderStore.activeOrder.HasPaymentMethod) || this.processingCheckout || (!this.state.isCustomAddressValid && this.state.ShowCustomShippingAddress)}
                                                            onClick={() => {
                                                                this.checkout();
                                                            }}
                                                            className="product-button-purchase"
                                                        >
                                                            {orderStore.activeOrder.OrderStatusId === 1 ?
                                                                <span>
                                                                {this.processingCheckout ? "*Bearbetar...*" : "Lägg beställning"}
                                                            </span>
                                                                : <span>Skickad&nbsp;<i key="icon"
                                                                                        className="material-icons check"></i></span>
                                                            }

                                                        </button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        {/*<div className="row">*/}
                                        {/*    <div className="col-6 pr-0">*/}
                                        {/*        {orderStore.activeOrder && !orderStore.activeOrder.ReadOnly ?*/}
                                        {/*            <button*/}
                                        {/*                disabled={!(orderStore.activeOrder.Valid && orderStore.activeOrder.HasShippingAddress && orderStore.activeOrder.HasPaymentMethod) || this.processingCheckout || (!this.state.isCustomAddressValid && this.state.ShowCustomShippingAddress)}*/}
                                        {/*                onClick={() => {*/}
                                        {/*                    this.checkout();*/}
                                        {/*                }}*/}
                                        {/*                className="btn btn-sm btn-success mr-1 mb-1"*/}
                                        {/*            >*/}
                                        {/*                {orderStore.activeOrder.OrderStatusId === 1 ?*/}
                                        {/*                    <span>*/}
                                        {/*                        {this.processingCheckout ? "*Bearbetar...*" : "Skicka beställning"}*/}
                                        {/*                    </span>*/}
                                        {/*                    : <span>Submitted&nbsp;<i key="icon" className="material-icons check"></i></span>*/}
                                        {/*                }*/}

                                        {/*            </button>*/}
                                        {/*            : null}*/}

                                        {/*        <button*/}
                                        {/*            disabled={this.processingCheckout}*/}
                                        {/*            onClick={() => {*/}
                                        {/*                orderStore.activeOrder.checkoutCancel().then((success) => {*/}
                                        {/*                    this.props.store.navigation.openOrder();*/}
                                        {/*                });*/}

                                        {/*            }}*/}
                                        {/*            className="btn btn-sm btn-secondary mb-1"*/}

                                        {/*        >*/}
                                        {/*            <span>*/}
                                        {/*                Avbryt*/}
                                        {/*		</span>*/}


                                        {/*        </button>*/}

                                        {/*    </div>*/}
                                        {/*    <div className="col-6 text-right">Ex. moms: <strong>{orderStore.activeOrder.SubTotalFormatted + " " + orderStore.activeOrder.Currency}</strong>*/}
                                        {/*        <br/>Moms: {orderStore.activeOrder.VATFormatted + " " + orderStore.activeOrder.Currency}*/}
                                        {/*        <br/>Att betala: {orderStore.activeOrder.OrderTotalFormatted + " " + orderStore.activeOrder.Currency}*/}
                                        {/*    </div>*/}

                                        {/*</div>*/}

                                    </React.Fragment>
                                }

                            </div>
                        </div>
                    </div>
                </ToolbarSection>
            </ToolbarDropdown>
        );
    }
}


export default withRouter(BerikssonPurchaseOrderCheckout);